import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import clsx from "clsx";
import { modalTypes } from "constants/types";
import { array, func } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { selectOfficeFileName } from "slices/addIn/metadata/selectors";
import { hideModal } from "slices/app/actions/modals";
import { selectOutlineData } from "slices/proposalOutline/selectors";

import classes from "./AddInConfirmOutlineInsert.module.scss";

const AddInConfirmOutlineInsert = ({ onCancel, onConfirmSubmit }) => {
  const dispatch = useDispatch();

  const officeFileName = useSelector(selectOfficeFileName);
  const outlineData = useSelector(selectOutlineData);

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.ADD_IN_CONFIRM_OUTLINE_INSERT));
    onCancel();
  };

  return (
    <Modal
      data-testid="has-unsaved-changes-modal"
      onDismiss={onDismiss}
      className={clsx("fade-in", classes.modal)}
      show
      centered
    >
      <Modal.Header>Confirm linkage</Modal.Header>

      <Modal.Body className={classes.body}>
        <p>
          You are about to create a new <strong>Proposal writing</strong> called{" "}
          <strong>{officeFileName}</strong> in{" "}
          <strong>{outlineData?.ownerName}</strong>{" "}
        </p>
        <p>Happy to go ahead?</p>
      </Modal.Body>

      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={onDismiss}
        >
          Cancel
        </NewButton>

        <NewButton
          data-testid="submit-button"
          variant={NewButtonVariant.l1}
          onClick={onConfirmSubmit}
        >
          Yes, Create
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

AddInConfirmOutlineInsert.propTypes = {
  childSections: array,
  onCancel: func,
  onConfirmSubmit: func,
};

export default AddInConfirmOutlineInsert;
